import cookie from 'utils/cookie'
import Result from './index'
import sagas from '../PersonalTasteProfile/sagas'

export default (injectSagas) => {
  // Inject the saga's only when the route is loaded. This happens only once.
  injectSagas(sagas)
  return [{
    path: 'mijn-profiel',
    component: Result,
    onEnter: () => {
      cookie.write('saveTasteProfile', cookie.read('saveTasteProfile') || 'true')
    }
  }]
}
